<div class="uber-token-panel">
  <h5 class="panel-title">Uber session token</h5>
  <p class="panel-help">
    Paste the Uber Cookie/Session Token to activate the Uber Business connection.
  </p>

  <div class="form-group">
    <label for="uberSession">Session</label>
    <textarea
      id="uberSession"
      class="form-control session-input"
      rows="10"
      [(ngModel)]="session"
      name="session"
      placeholder="Paste Uber cookie/session here"
      autocomplete="off"
      spellcheck="false"
    ></textarea>
  </div>

  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!canSubmit"
    (click)="activateToken()"
  >
    {{ isSubmitting ? "Activating..." : "Activate Token" }}
  </button>
</div>
